import { Component, Input, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { CILMasterService } from 'src/app/services/cil-master-service';
import { NzI18nService, zh_CN } from "ng-zorro-antd/i18n";
import { TranslaterService } from 'src/app/services/translater.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { ApplicationPermission } from 'src/app/user-management/shared/models/application-permission';

@Component({
  selector: 'app-safety-header',
  templateUrl: './safety-header.component.html',
  styleUrls: ['./safety-header.component.scss']
})
export class SafetyHeaderComponent implements OnInit {
  ImageUrl: any;
  user: any;
  HeaderForm: any;
  HeaderData: any = { Group: '', Unit: '', UnitName: '', Date: new Date() };
  formDirective: any;
  unitPickerIsOpen: boolean = false;
  isAccess = ApplicationPermission.SAFETY_ENVIRONMENT_ACCESS;
  isCreate = ApplicationPermission.SAFETY_ENVIRONMENT_CREATE;
  isUpdate = ApplicationPermission.SAFETY_ENVIRONMENT_UPDATE;
  isDelete = ApplicationPermission.SAFETY_ENVIRONMENT_DELETE;
  @Output() add = new EventEmitter();
  @Output() emitHeaderData = new EventEmitter<any>();
  spinnerText: string = '';
  GroupTempList: any = [];
  breadcrumList: any;
  pageId: any;
  moduleId: any;
  langObj: any;
  languageDir = 'ltr'

  constructor(private toaster: ToastrService, private fb: FormBuilder, public router: Router, private spinner: NgxSpinnerService, private formBuilder: FormBuilder, public datePipe: DatePipe, public dialog: MatDialog, private cilMasterService: CILMasterService, private i18n: NzI18nService, private translater: TranslaterService, private translate: TranslateService, private usermanagementService: UserManagementService) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ? this.languageDir = 'rtl' : this.languageDir = 'ltr'; this.getLangWords(); })
    this.HeaderForm = this.fb.group({
      Unit: ['', Validators.required],
      Date: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.user = localStorage.getItem('user');
    this.user = JSON.parse(this.user);
  }


  public getLangWords() {
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : this.translate.currentLang === 'gr' ? 5 : this.translate.currentLang === 'du' ? 6 : 1
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
    });
  }



  setUnit(event: any) {
    this.HeaderData.Unit = event.Id;
    this.HeaderData.UnitName = event.Name;
    this.unitPickerIsOpen = false;
    if (this.HeaderData.Unit) {
      let date = this.datePipe.transform(this.HeaderData.Date, 'yyyy/MM/dd');
      const data = {
        UserId: 0,
        PUId: this.HeaderData.Unit,
        Date: date
      };
      this.emitHeaderData.emit(data);
    }
  }

  onChange(event: any) {
    if (this.HeaderData.Unit) {
      let date = this.datePipe.transform(this.HeaderData.Date, 'yyyy/MM/dd');
      const data = {
        UserId: 0,
        PUId: this.HeaderData.Unit,
        Date: date
      };
      this.emitHeaderData.emit(data);
    }
  }

  resetUnit() {
    this.HeaderData.Unit = 0;
    this.HeaderData.UnitName = '';
    this.unitPickerIsOpen = false;
  }

  openModal() {
    this.unitPickerIsOpen = true;
  }



  onSubmit() {
    if (this.HeaderForm.valid)
      this.add.emit(this.HeaderData);
  }

}
